import { InternalObjectEditor } from "./InternalObjectEditor";
import { ObjectEditorContextProvider, ObjectEditorItemOptions } from "./ObjectEditorContext";

interface ObjectEditorProps<T extends Record<string, unknown>> {
  object: T;
  setObject: React.Dispatch<React.SetStateAction<T>>;
  objectTemplate: ObjectEditorItemOptions[];
}

/**
 * Top-level object editor component that renders an editor for each
 * property in the provided object based on the provided template.
 *
 * @param props - Component props including the object to edit, a setter
 *        function and the template describing editable fields.
 * @param props.object - The object instance being edited.
 * @param props.setObject - Setter function to update the object state.
 * @param props.objectTemplate - Template describing fields and editors.
 */
export const ObjectEditor = <T extends Record<string, unknown>>({
  object,
  setObject,
  objectTemplate,
}: ObjectEditorProps<T>) => {
  return (
    <ObjectEditorContextProvider
      object={object}
      setObject={setObject}
      objectTemplate={objectTemplate}
    >
      {Object.keys(object).map((property, ix) => (
        <InternalObjectEditor
          dataPath={property}
          key={`${ix}-${property}`}
        />
      ))}
    </ObjectEditorContextProvider>
  );
};

ObjectEditor.displayName = "ObjectEditor";
export default ObjectEditor;
